import { createSlice } from '@reduxjs/toolkit';

import { RootState } from 'store';

import { AnalyticsExportState, AnalyticsExportStatus } from './types';

const initialState: AnalyticsExportState = {
  caseId: 0,
  file: null,
  queueRoomId: '',
  formValues: null,
  hospitalId: false,
  isButtonHide: false,
  panelMinimized: false,
  isShowFeedback: false,
  queueAlertResetKey: 0,
  callFlowTextOut: false,
  isShowPlanForCVT: false,
  callFlowInProgress: false,
  is_hospital_edit_enabled: false,
  status: AnalyticsExportStatus.Initial,
};

const analyticsExportSlice = createSlice({
  initialState,
  name: 'analyticsExport',
  reducers: {
    reset: () => initialState,
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    setCaseId: (state, action) => {
      state.caseId = action.payload;
    },
    setHospitalId: (state, action) => {
      state.hospitalId = action.payload;
    },
    setQueueRoomId: (state, action) => {
      state.queueRoomId = action.payload;
    },
    setIsButtonHide: (state, action) => {
      state.isButtonHide = action.payload;
    },
    setIsShowFeedback: (state, action) => {
      state.isShowFeedback = action.payload;
    },
    setPanelMinimized: (state, action) => {
      state.panelMinimized = action.payload;
    },
    setCallFlowTextOut: (state, action) => {
      state.callFlowTextOut = action.payload;
    },
    setIsShowPlanForCVT: (state, action) => {
      state.isShowPlanForCVT = action.payload;
    },
    setCallFlowInProgress: (state, action) => {
      state.callFlowInProgress = action.payload;
    },
    setIsHospitalEditEnabled: (state, action) => {
      state.is_hospital_edit_enabled = action.payload;
    },
    resetQueueAlertTimer: (state) => {
      state.queueAlertResetKey = Date.now(); // or just increment a number
    },
    fileProcessed: (state, action) => {
      state.status = AnalyticsExportStatus.Ready;
      state.file = action.payload;
    },
    setFormValues: (state, action) => {
      state.formValues = {
        ...state.formValues,
        ...action.payload,
      };
    },
  },
});

const {
  reducer: analyticsExportReducer,
  actions: {
    reset,
    setStatus,
    setCaseId,
    setHospitalId,
    fileProcessed,
    setFormValues,
    setQueueRoomId,
    setIsButtonHide,
    setIsShowFeedback,
    setPanelMinimized,
    setCallFlowTextOut,
    setIsShowPlanForCVT,
    resetQueueAlertTimer,
    setCallFlowInProgress,
    setIsHospitalEditEnabled,
  },
} = analyticsExportSlice;

const selectAnalyticsExport = (state: RootState) => state.analyticsExport;

export {
  reset,
  setStatus,
  setCaseId,
  setHospitalId,
  fileProcessed,
  setFormValues,
  setQueueRoomId,
  setIsButtonHide,
  setIsShowFeedback,
  setPanelMinimized,
  setCallFlowTextOut,
  setIsShowPlanForCVT,
  resetQueueAlertTimer,
  setCallFlowInProgress,
  AnalyticsExportStatus,
  selectAnalyticsExport,
  analyticsExportReducer,
  setIsHospitalEditEnabled,
};

export type { AnalyticsExportState };
